/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Option_LabelInputs */

const en_segment_event_group_option_label = /** @type {(inputs: Segment_Event_Group_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentation Option`)
};

const fr_segment_event_group_option_label = /** @type {(inputs: Segment_Event_Group_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Option de segmentation`)
};

const de_segment_event_group_option_label = /** @type {(inputs: Segment_Event_Group_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentierungsoption`)
};

const it_segment_event_group_option_label = /** @type {(inputs: Segment_Event_Group_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzione di segmentazione`)
};

const ru_segment_event_group_option_label = /** @type {(inputs: Segment_Event_Group_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вариант сегментации`)
};

const es_segment_event_group_option_label = /** @type {(inputs: Segment_Event_Group_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opción de segmentación`)
};

const zh_cn2_segment_event_group_option_label = /** @type {(inputs: Segment_Event_Group_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`细分选项`)
};

const ja_segment_event_group_option_label = /** @type {(inputs: Segment_Event_Group_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セグメンテーションオプション`)
};

const hi_segment_event_group_option_label = /** @type {(inputs: Segment_Event_Group_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विभाजन विकल्प`)
};

const pt_pt2_segment_event_group_option_label = /** @type {(inputs: Segment_Event_Group_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opção de Segmentação`)
};

/**
* | output |
* | --- |
* | "Segmentation Option" |
*
* @param {Segment_Event_Group_Option_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_option_label = /** @type {((inputs?: Segment_Event_Group_Option_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Option_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_option_label(inputs)
	if (locale === "de") return de_segment_event_group_option_label(inputs)
	if (locale === "it") return it_segment_event_group_option_label(inputs)
	if (locale === "ru") return ru_segment_event_group_option_label(inputs)
	if (locale === "es") return es_segment_event_group_option_label(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_option_label(inputs)
	if (locale === "ja") return ja_segment_event_group_option_label(inputs)
	if (locale === "hi") return hi_segment_event_group_option_label(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_option_label(inputs)
	return en_segment_event_group_option_label(inputs)
});